import { CloseCircleTwoTone } from '@ant-design/icons';
import theme from '@css/theme';
import { Flex } from '@ui-library/misc';
import React from 'react';
import styled from 'styled-components';
import { isNot } from 'typescript-styled-is';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const IconWrapper = styled.div<{ done?: boolean }>`
  margin-right: 10px;
  ${isNot('done')`
    opacity:0;
  `}
`;
const TitleWrapper = styled.div`
  margin-right: 10px;
`;

const ErrorWrapper = styled.div`
  color: ${theme.color.error};
  font-weight: 500;
  margin-top: 12px;
  word-break: break-all;
`;

interface StatusTitleProps {
  error?: string | null;
  done?: boolean;
  title: string;
  showError?: boolean;
}

const StatusTitle = ({ error, title, done, showError = true }: StatusTitleProps) => (
  <Flex>
    <IconWrapper done={done}>
      {error ? (
        <CloseCircleTwoTone twoToneColor={theme.color.error} />
      ) : (
        <FontAwesomeIcon icon={solid('circle-check')} color={theme.color.success} />
      )}
    </IconWrapper>
    <TitleWrapper>
      <div>{title}</div>
      {showError && error && done && <ErrorWrapper>{error}</ErrorWrapper>}
    </TitleWrapper>
  </Flex>
);

export default StatusTitle;
